import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChevronDown, Plus, Share2, Eye, Heart } from 'lucide-react';

const PremiumDashboard = ({ dashboardData = {} }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('LAST_30_DAYS');
  const [actions, setActions] = useState([
    {
      id: 1,
      userName: 'Peter White',
      action: 'wants to use the coupon and pay by Dollars.',
      avatar: '👤',
    },
    {
      id: 2,
      userName: 'Profile',
      action: 'Have to complete !',
      avatar: '👤',
    },
    {
      id: 3,
      userName: 'Norman',
      action: 'wants to use the coupon and pay by Dollars.',
      avatar: '👤',
    },
    {
      id: 4,
      userName: 'Profile',
      action: 'Have to complete !',
      avatar: '👤',
    },
  ]);

  // Mock data - replace with your API data
  const [chartData] = useState([
    { month: 'JAN', redemptions: 30, pointsBack: 20 },
    { month: 'FEB', redemptions: 20, pointsBack: 30 },
    { month: 'MAR', redemptions: 25, pointsBack: 28 },
    { month: 'APR', redemptions: 35, pointsBack: 22 },
    { month: 'MAY', redemptions: 40, pointsBack: 35 },
    { month: 'JUN', redemptions: 30, pointsBack: 25 },
  ]);

  const [pointsChartData] = useState([
    { month: 'JAN', points: 19, dollars: 2070 },
    { month: 'FEB', points: 15, dollars: 1800 },
    { month: 'MAR', points: 20, dollars: 2200 },
    { month: 'APR', points: 18, dollars: 1950 },
    { month: 'MAY', points: 22, dollars: 2400 },
    { month: 'JUN', points: 25, dollars: 2600 },
  ]);

  const [pointRequests] = useState([
    { firstName: 'Lan', dateTime: 'Jan - 12, 13:30', points: 12, status: 'Expired' },
    { firstName: 'Moris', dateTime: 'Feb - 06, 05:23', points: 4, status: 'Done' },
    { firstName: 'John', dateTime: 'Feb - 11, 12:20', points: 7, status: 'Done' },
    { firstName: 'Freddy', dateTime: 'Feb - 12, 02:12', points: 10, status: 'Active' },
    { firstName: 'Freddy', dateTime: 'Feb - 12, 02:12', points: 10, status: 'Active' },
    { firstName: 'Freddy', dateTime: 'Feb - 12, 02:12', points: 10, status: 'Active' },
    { firstName: 'Freddy', dateTime: 'Feb - 12, 02:12', points: 10, status: 'Active' },
    { firstName: 'Freddy', dateTime: 'Feb - 12, 02:12', points: 10, status: 'Active' },
  ]);

  const [coupons] = useState([
    { id: 1, title: 'Take a Cup', expiry: 'Jan 01', favorites: 145, views: 205 },
    { id: 2, title: 'Take a Cup', expiry: 'Jan 01', favorites: 145, views: 205 },
    { id: 3, title: 'Take a Cup', expiry: 'Jan 01', favorites: 145, views: 205 },
    { id: 4, title: 'Take a Cup', expiry: 'Jan 01', favorites: 145, views: 205 },
    { id: 5, title: 'Take a Cup', expiry: 'Jan 01', favorites: 145, views: 205 },
    { id: 6, title: 'Take a Cup', expiry: 'Jan 01', favorites: 145, views: 205 },
  ]);

  // Business info - from your API
  const businessInfo = {
    name: 'Mannyo',
    followers: 14,
    referrals: 768,
    location: 'Take A Break cafe',
    profit: '12%',
    image: 'https://images.unsplash.com/photo-1495521821757-a1efb6729352?w=400&h=400&fit=crop',
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'expired':
        return 'text-red-600 bg-red-50';
      case 'done':
        return 'text-green-600 bg-green-50';
      case 'active':
        return 'text-blue-600 bg-blue-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const periodOptions = [
    { value: 'TOTAL', label: 'All Time' },
    { value: 'LAST_YEAR', label: 'Last Year' },
    { value: 'LAST_30_DAYS', label: 'Last 30 Days' },
    { value: 'LAST_7_DAYS', label: 'Last 7 Days' },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-rose-50">
      {/* Hero Section */}
      <div className="bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex justify-between items-start gap-8">
            <div>
              <h1 className="text-4xl font-bold text-slate-900">
                Welcome in, <span className="text-slate-700 font-bold">{businessInfo.name}</span> !
              </h1>
              <div className="flex gap-8 mt-6">
                <div>
                  <div className="text-red-500 text-2xl font-bold">❤️ {businessInfo.followers}</div>
                  <div className="text-sm text-slate-600 mt-1">Total Followers</div>
                </div>
                <div>
                  <div className="text-red-500 text-2xl font-bold">📤 {businessInfo.referrals}</div>
                  <div className="text-sm text-slate-600 mt-1">Total Referrals</div>
                </div>
              </div>
            </div>

            {/* Feature Banner */}
            <div className="bg-gradient-to-br from-yellow-300 via-yellow-200 to-yellow-100 rounded-3xl p-6 shadow-xl max-w-sm">
              <div className="text-center">
                <p className="text-gray-700 text-sm font-semibold">New Feature Launch.</p>
                <h3 className="text-2xl font-bold text-gray-900 mt-2">Boost your Coupon Reach!</h3>
                <button className="mt-4 px-6 py-2 border-2 border-orange-400 text-orange-600 font-semibold rounded-lg hover:bg-orange-50 transition">
                  Learn more
                </button>
              </div>
              <div className="mt-4 flex justify-center gap-2 text-4xl">
                💰 👑 💰
              </div>
              <div className="absolute top-4 right-4 text-6xl">👩</div>
            </div>
          </div>

          {/* Period Selector */}
          <div className="mt-6 flex items-center gap-3">
            <label className="text-sm font-medium text-slate-700">Period:</label>
            <select
              value={selectedPeriod}
              onChange={(e) => setSelectedPeriod(e.target.value)}
              className="px-4 py-2 rounded-lg border-2 border-slate-200 bg-white text-slate-900 font-medium hover:border-red-400 focus:outline-none focus:border-red-500 transition"
            >
              {periodOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Charts and Tables */}
          <div className="lg:col-span-2 space-y-6">
            {/* Business Card */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-slate-200 hover:shadow-lg transition">
              <div className="relative h-40 bg-gradient-to-br from-rose-500 to-orange-600">
                <img
                  src={businessInfo.image}
                  alt={businessInfo.name}
                  className="w-full h-full object-cover opacity-70"
                />
              </div>
              <div className="p-6 flex justify-between items-end">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-white rounded-full shadow-lg flex items-center justify-center text-2xl border-4 border-rose-500">
                    ☕
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-900">{businessInfo.name}</h3>
                    <p className="text-sm text-slate-600">{businessInfo.location}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-red-600">{businessInfo.profit}</div>
                  <div className="text-sm text-slate-600">Profit</div>
                </div>
              </div>
            </div>

            {/* Charts Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Redemptions Chart */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="font-semibold text-slate-900">Redemptions</h3>
                  <button className="flex items-center gap-2 px-3 py-2 text-sm rounded-lg bg-slate-100 hover:bg-slate-200 transition">
                    <ChevronDown size={16} />
                    Last 30 Days
                  </button>
                </div>

                <div className="flex gap-8 mb-6 pb-6 border-b border-slate-200">
                  <div>
                    <div className="text-sm text-slate-600">Amount Off</div>
                    <div className="text-2xl font-bold text-slate-900">26</div>
                  </div>
                  <div>
                    <div className="text-sm text-slate-600">Points Back</div>
                    <div className="text-2xl font-bold text-slate-900">16</div>
                  </div>
                  <div>
                    <div className="text-sm text-slate-600">Total</div>
                    <div className="text-2xl font-bold text-slate-900">16</div>
                  </div>
                </div>

                <ResponsiveContainer width="100%" height={200}>
                  <LineChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="month" stroke="#999" style={{ fontSize: '12px' }} />
                    <YAxis stroke="#999" style={{ fontSize: '12px' }} />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px',
                      }}
                    />
                    <Line
                      type="monotone"
                      dataKey="redemptions"
                      stroke="#e91e63"
                      strokeWidth={2}
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="pointsBack"
                      stroke="#ffc107"
                      strokeWidth={2}
                      dot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>

              {/* Points & Dollars Chart */}
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
                <div className="flex justify-between items-center mb-6">
                  <h3 className="font-semibold text-slate-900">Points & Dollars</h3>
                  <button className="flex items-center gap-2 px-3 py-2 text-sm rounded-lg bg-slate-100 hover:bg-slate-200 transition">
                    <ChevronDown size={16} />
                    Last 30 Days
                  </button>
                </div>

                <div className="flex gap-8 mb-6 pb-6 border-b border-slate-200">
                  <div>
                    <div className="text-sm text-slate-600">Points</div>
                    <div className="text-2xl font-bold text-slate-900">19.12</div>
                  </div>
                  <div>
                    <div className="text-sm text-slate-600">Dollars</div>
                    <div className="text-2xl font-bold text-slate-900">2070.78</div>
                  </div>
                  <div>
                    <div className="text-sm text-slate-600">Total</div>
                    <div className="text-2xl font-bold text-slate-900">16</div>
                  </div>
                </div>

                <ResponsiveContainer width="100%" height={200}>
                  <LineChart data={pointsChartData}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis dataKey="month" stroke="#999" style={{ fontSize: '12px' }} />
                    <YAxis stroke="#999" style={{ fontSize: '12px' }} />
                    <Tooltip
                      contentStyle={{
                        backgroundColor: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px',
                      }}
                    />
                    <Line
                      type="monotone"
                      dataKey="points"
                      stroke="#e91e63"
                      strokeWidth={2}
                      dot={false}
                    />
                    <Line
                      type="monotone"
                      dataKey="dollars"
                      stroke="#ffc107"
                      strokeWidth={2}
                      dot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Point Requests Table */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="font-semibold text-slate-900">Point Requests</h3>
                <button className="flex items-center gap-2 px-3 py-2 text-sm rounded-lg bg-slate-100 hover:bg-slate-200 transition">
                  <ChevronDown size={16} />
                </button>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-slate-200">
                      <th className="text-left py-3 px-4 font-semibold text-slate-900">First name</th>
                      <th className="text-left py-3 px-4 font-semibold text-slate-900">Date and time</th>
                      <th className="text-left py-3 px-4 font-semibold text-slate-900">Points</th>
                      <th className="text-left py-3 px-4 font-semibold text-slate-900">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pointRequests.map((req, idx) => (
                      <tr
                        key={idx}
                        className="border-b border-slate-100 hover:bg-slate-50 transition"
                      >
                        <td className="py-3 px-4 text-slate-900 font-medium">{req.firstName}</td>
                        <td className="py-3 px-4 text-slate-600">{req.dateTime}</td>
                        <td className="py-3 px-4 text-slate-900 font-medium">{req.points}</td>
                        <td className="py-3 px-4">
                          <span
                            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(
                              req.status
                            )}`}
                          >
                            {req.status}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Right Column - Sidebar */}
          <div className="space-y-6">
            {/* Premium Card */}
            <div className="relative bg-gradient-to-br from-red-600 to-red-700 rounded-2xl p-8 text-white shadow-xl overflow-hidden">
              {/* QR Code placeholder */}
              <div className="absolute top-4 right-4 w-20 h-20 bg-white rounded-lg flex items-center justify-center shadow-lg">
                <div className="text-center text-xs text-gray-600">
                  <div className="w-16 h-16 bg-gray-200 rounded flex items-center justify-center">📱</div>
                </div>
              </div>

              <div className="text-4xl font-bold mb-2">👑</div>
              <h3 className="text-3xl font-bold mb-1">Premium</h3>

              <div className="mt-8 pt-8 border-t border-red-400 border-opacity-50">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="text-sm text-red-100">Business name</p>
                    <p className="font-semibold text-white mt-1">{businessInfo.name}</p>
                  </div>
                  <button className="px-4 py-2 bg-red-500 hover:bg-red-600 rounded-lg text-sm font-semibold transition transform hover:scale-105">
                    Take a brake
                  </button>
                </div>
              </div>

              <div className="mt-6 flex gap-2">
                <Eye size={20} />
              </div>
            </div>

            {/* Actions Section */}
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-bold text-slate-900">
                  <span className="text-red-600">◯◯</span> Actions
                </h3>
                <button className="p-2 rounded-full bg-slate-100 hover:bg-slate-200 transition">
                  <Share2 size={18} className="text-slate-600" />
                </button>
              </div>

              <div className="space-y-3 max-h-96 overflow-y-auto">
                {actions.map((action) => (
                  <div
                    key={action.id}
                    className="flex gap-4 p-4 bg-rose-50 rounded-lg border border-rose-100 hover:border-rose-300 transition group"
                  >
                    <div className="flex-shrink-0">
                      <div className="w-10 h-10 rounded-full bg-slate-300 flex items-center justify-center text-lg">
                        👤
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-slate-900 group-hover:text-red-600 transition">
                        {action.userName}
                      </p>
                      <p className="text-xs text-slate-600 mt-1">{action.action}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Coupons Sidebar */}
      <div className="fixed bottom-8 left-8 w-80 bg-white rounded-2xl shadow-2xl border border-slate-200 max-h-96 flex flex-col">
        <div className="p-6 border-b border-slate-200 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <span className="text-xl">🎟️</span>
            <h3 className="text-xl font-bold text-slate-900">Coupons</h3>
          </div>
          <button className="w-10 h-10 rounded-lg bg-red-600 hover:bg-red-700 text-white flex items-center justify-center transition transform hover:scale-110">
            <Plus size={20} />
          </button>
        </div>

        <div className="p-4 border-b border-slate-200">
          <p className="text-3xl font-bold text-slate-900">04/06</p>
          <div className="flex gap-2 mt-3">
            <button className="w-8 h-8 rounded-full border-2 border-slate-300 hover:border-red-500 transition flex items-center justify-center text-xs">
              ❤️
            </button>
            <button className="w-8 h-8 rounded-full border-2 border-slate-300 hover:border-red-500 transition flex items-center justify-center text-xs">
              ✎
            </button>
          </div>
        </div>

        <div className="flex gap-2 p-4 border-b border-slate-200">
          <button className="flex-1 px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition text-sm">
            📤 Published
          </button>
          <button className="flex-1 px-4 py-2 bg-slate-100 text-slate-900 font-semibold rounded-lg hover:bg-slate-200 transition text-sm">
            📝 Unpublished
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {coupons.map((coupon) => (
            <div key={coupon.id} className="p-3 border border-slate-200 rounded-lg hover:border-red-400 transition">
              <div className="flex items-center gap-2 mb-2">
                <input type="checkbox" checked className="w-4 h-4 accent-red-600" readOnly />
                <h4 className="text-sm font-semibold text-slate-900 flex-1">{coupon.title}</h4>
              </div>
              <div className="text-xs text-slate-600 mb-2">Expire: {coupon.expiry}</div>
              <div className="flex gap-3 text-xs">
                <span className="flex items-center gap-1">
                  <Heart size={14} className="text-red-600" />
                  {coupon.favorites}
                </span>
                <span className="flex items-center gap-1">
                  <Eye size={14} className="text-slate-600" />
                  {coupon.views}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PremiumDashboard;